import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return (
      data.payments_tokens.length > 0 &&
      data.payments_token_fee_eligibility_jobs.length === 0
    )
  }, [data])
}
